define('controllers/myreport/myreport-app-adbanalysis.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('AdBAnalysisReport', ['$scope', '$q', 'OpenApp', 'OpenOther', 'auiDialog', '$filter', 'reportUtil',
        function ($scope, $q, OpenApp, OpenOther, auiDialog, $filter, reportUtil) {
            /* 1. 局部变量声明 */
            /* 2. $scope变量声明 */
            var Model = $scope.Model = {
                tabType: 'revenue',
                revenueMagicType: 'line',
                effectMagicType: 'line',
                adAppGetRevenue: {
                    // 这里可以什么都不写，直接用默认值
                    appId: '-1',                    //【产品下拉框】【默认值】-1
                    regionShow: [0, 3, 5, 6],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 3,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    timeQuantum: 31,
                    adType: -1,                      //广告形式 默认值】-1 【枚举】-1：全部0:开屏1:锁屏
                    queryMethod: adAppGetRevenueList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: adAppDownRevenueList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮
                    onload: init,
                    appListQueryMethod: $scope.$parent.initAppList('adAppRevenue', 41)
                },
                adAppGetEffect: {
                    // 传递哪些筛选条件，哪些筛选条件就展示。全集如下
                    appId: '-1',                    //【产品下拉框】【默认值】-1
                    regionShow: [0, 3, 5, 6],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 3,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    timeQuantum: 31,
                    adType: -1,                     //广告形式 默认值】-1 【枚举】-1：全部0:开屏1:锁屏
                    requestAll: -1,                   //广告效果报表 请求量
                    impressionAll: 1,                 //广告效果报表 展现量
                    clickAll: -1,                      //广告效果报表 点击量
                    fillRate: -1,                      //广告效果报表 填充率
                    clickRate: -1,                     //广告效果报表 点击率
                    income: 1,                        //广告效果报表 收入
                    queryMethod: adAppGetEffectList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadAdAppeffectList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮
                    appListQueryMethod: $scope.$parent.initAppList('adAppeffect', 41)
                },
                paginationAppRevenue: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeDownload
                },
                paginationAppEffect: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeEffect
                },
                adAppGetRevenueList: null,
                adAppeffectList: null,
                downloadRevenueCharts: {
                    id: "myreport.adbanalysis.revenue",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                downloadEffectCharts: {
                    id: "myreport.adbanalysis.effect",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                }
            };
            Model.variableOfScope = 'variable of scope';
            /* 3. $scope函数挂载 */
            $scope.changeTabType = changeTabType;
            $scope.adAppGetRevenueList = adAppGetRevenueList;
            $scope.adAppDownRevenueList = adAppDownRevenueList;
            $scope.adAppGetEffectList = adAppGetEffectList;
            $scope.downloadAdAppeffectList = downloadAdAppeffectList;
            /* 4. 初始化函数声明与执行 */
            function init() {
                changeTabType();
            }

            /* 5. 函数声明 */
            function changeTabType(type) {
                if (type) {
                    Model.tabType = type;
                }
                switch (Model.tabType) {
                    case 'revenue':
                        if (Model.adAppGetRevenueList == null) {
                            adAppGetRevenueList();
                        }
                        break;
                    case 'effect':
                        if (Model.adAppeffectList == null) {
                            adAppGetEffectList();
                        }
                        break;
                }
            }

            /* 5. 函数声明 */
            function adAppGetRevenueList() {
                var params = getDownloadReportParams();
                if(!$scope.$parent.checkDate(params)) {
                    auiDialog.fail("时间区间选择错误","查询时间不得为空");
                    return;
                }
                OpenOther.getReportAdAppBI(params).then(function (data) {
                    Model.adAppGetRevenueList = getBI(data);
                    Model.paginationAppRevenue.totalCount = Model.adAppGetRevenueList.total;

                    getEchartConfig();
                    Model.paginationAppRevenue.currentPage = 1;
                    Model.paginationAppRevenue.itemsPerPage= Model.paginationAppRevenue.itemsPerPageBackUp;
                    pageChangeDownload();
                    Model.topModel = getBIForRevenueTop(data)
                });
            }

            function adAppDownRevenueList() {
                var params = getDownloadReportParams();
                if(!$scope.$parent.checkDate(params)) {
                    auiDialog.fail("时间区间选择错误","查询时间不得为空");
                    return;
                }
                $scope.$parent.downloadReport(OpenOther.exportReportAdAppBI, params, function (resp) {
                    return resp && resp.retCode == 0;
                });
            }
            
            function getDownloadReportParams() {
                var params = {
                    appId: Model.adAppGetRevenue.appId,
                    startTime: Model.adAppGetRevenue.startTime,
                    endTime: AUI.DateUtil.getEndTime(Model.adAppGetRevenue.endTime),
                    pageNum : 0,
                    pageSize: 0,
                    adType: Model.adAppGetRevenue.adType
                };
                AUI.BaseJSUtil.mergeJSON(Model.adAppGetRevenue, params);
                return params;

            }

            /* 5. 函数声明 */
            function adAppGetEffectList() {

                if(checkedCount()){
                    return;
                }
                var params = {
                    appId: Model.adAppGetEffect.appId,
                    startTime: Model.adAppGetEffect.startTime,
                    endTime: Model.adAppGetEffect.endTime,
                    pageNum : 0,
                    pageSize:0,
                    adType: Model.adAppGetEffect.adType
                };

                AUI.BaseJSUtil.mergeJSON(Model.adAppGetEffect, params);

                if(!$scope.$parent.checkDate(params)) {
                    auiDialog.fail("时间区间选择错误","查询时间不得为空");
                    return;
                }
                Model.EffectTopModel = {};
                OpenOther.getReportAdAppEffectBI(params).then(function (data) {
                    Model.adAppeffectList = getAdAppGetEffect(data);
                    Model.paginationAppEffect.totalCount = Model.adAppeffectList.totalCount;
                    getEchartForEffectConfig();
                    Model.paginationAppEffect.currentPage = 1;
                    Model.paginationAppEffect.itemsPerPage=Model.paginationAppEffect.itemsPerPageBackUp;
                    pageChangeEffect();
                    if (data && data.returnCode == 200) {
                        Model.EffectTopModel.impressionAll = $filter('number')(data.impressionAll) + "次";
                        Model.EffectTopModel.clickAll = $filter('number')(data.clickAll) + "次";
                        Model.EffectTopModel.income = data.income;
                    }
                    else {
                        Model.EffectTopModel.impressionAll = '--';
                        Model.EffectTopModel.clickAll = '--';
                        Model.EffectTopModel.income = '0.00';
                    }
                }).catch(function () {
                    Model.EffectTopModel.impressionAll = '--';
                    Model.EffectTopModel.clickAll = '--';
                    Model.EffectTopModel.income = '0.00';

                });
            }
               function checkedCount() {
                   var flag=false;

                   var checkedCount=0;
                   if(Model.adAppGetEffect.requestAll==1){
                       checkedCount++;
                   }
                   if(Model.adAppGetEffect.impressionAll==1){
                       checkedCount++;
                   }
                   if(Model.adAppGetEffect.clickAll==1){
                       checkedCount++;
                   }
                   if(Model.adAppGetEffect.clickRate==1){
                       checkedCount++;
                   }
                   if(Model.adAppGetEffect.fillRate==1){
                       checkedCount++;
                   }
                   if(Model.adAppGetEffect.income==1){
                       checkedCount++;
                   }
                   if(checkedCount>2){
                       auiDialog.fail("最多能选2个查看");
                        return true;
                   }
                   if(checkedCount==0){
                       auiDialog.fail("最少选1个查看");
                       return true;
                   }
                   return flag;
               }
            function downloadAdAppeffectList() {
                var params = {
                    appId: Model.adAppGetEffect.appId,
                    startTime: Model.adAppGetEffect.startTime,
                    endTime: AUI.DateUtil.getEndTime(Model.adAppGetEffect.endTime),
                    pageNum : 0,
                    pageSize:0,
                    adType: Model.adAppGetEffect.adType
                };

                AUI.BaseJSUtil.mergeJSON(Model.adAppGetEffect, params);

                if(!$scope.$parent.checkDate(params)) {
                    auiDialog.fail("时间区间选择错误","查询时间不得为空");
                    return;
                }

                $scope.$parent.downloadReport( OpenOther.exportReportAdAppEffectBI, params, function (resp) {
                    return resp && resp.retCode == 0;
                });
            }

            function getEchartConfig() {
                var result = reportUtil.getXYFromBI(Model.adAppGetRevenueList.reportHicloudList, "date", 1,
                    ["income"]);

                Model.downloadRevenueCharts.options = (result && result['date'] && result['date'].length > 0) ? {
                    legend: {
                        data: ['收入(￥)']
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: result["date"]
                    }],
                    yAxis: [{ // 纵坐标
                        type: 'value'
                    }],
                    series: [

                        {
                            "name": "收入(￥)",
                            "type": Model.revenueMagicType,
                            "data": result["income"]
                        }]


                } : null;
            }

            function getEchartForEffectConfig() {
                var effectResult = reportUtil.getXYFromBI(Model.adAppeffectList.adAppeffectList, "date", 1,
                    ["requestAll", "impressionAll", "clickAll", "fillRate", "clickRate", "income"]);

                  var dataTitle=[];
                  var dataValueStr=[];
                if(Model.adAppGetEffect.requestAll==1){
                    dataTitle.push('请求量(次)');
                    dataValueStr.push("requestAll");
                }
                if(Model.adAppGetEffect.impressionAll==1){
                    dataTitle.push('展现量(次)');
                    dataValueStr.push("impressionAll");
                }
                if(Model.adAppGetEffect.clickAll==1){
                    dataTitle.push('点击量(次)');
                    dataValueStr.push("clickAll");
                }
                if(Model.adAppGetEffect.fillRate==1){
                    dataTitle.push('填充率(%)');
                    dataValueStr.push("fillRate");
                }
                if(Model.adAppGetEffect.clickRate==1){
                    dataTitle.push('点击率(%)');
                    dataValueStr.push("clickRate");
                }
                if(Model.adAppGetEffect.income==1){
                    dataTitle.push('收入(￥)');
                    dataValueStr.push("income");
                }
                if(Model.adAppGetEffect.eCPM==1){
                    dataTitle.push('eCPM');
                    dataValueStr.push("eCPM");
                }
                var seriesValue=[];
                for(var i=0;i<dataTitle.length;i++){
                    seriesValue.push( {
                        "name": dataTitle[i],
                        "type": Model.effectMagicType,
                        "data": effectResult[dataValueStr[i]]
                    });

                }
                Model.downloadEffectCharts.options = (effectResult && effectResult['date'] && effectResult['date'].length > 0) ? {
                    legend: {

                        data: dataTitle
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: effectResult["date"]
                    }],
                    yAxis: [{ // 纵坐标
                        type: 'value'
                    }],
                    series:
                        seriesValue
                } : null;
            }

            /**
             * 这里做前台分页，不需要重新查询一次接口
             */
            function pageChangeDownload() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.adAppGetRevenueList.reportHicloudList, Model.paginationAppRevenue));
                Model.downloadListForShow = result.listForShow;
            }

            /**
             * 这里做前台分页，不需要重新查询一次接口
             */
            function pageChangeEffect() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.adAppeffectList.adAppeffectList, Model.paginationAppEffect));
                Model.downloadListForEffectShow = result.listForShow;
            }

            function getAdAppGetEffect(data) {

                var list = [];
                var totalCount = 0;
                if (data && data.returnCode == 200) {
                    list = data.adAppeffectList;
                    totalCount = data.total;
                }

                return {
                    "totalCount": totalCount,
                    "adAppeffectList": list
                }
            }

            function getBIForRevenueTop(data) {
                var yesIncome = 0.00;
                var monIncome = 0.00;

                if (data && data.returnCode == 200) {

                    yesIncome = data.yesIncome;
                    monIncome = data.monIncome;
                }

                return {
                    "yesIncome": yesIncome,
                    "monIncome": monIncome
                }
            }

            function getBI(data) {
                var list = [];
                var totalCount = 0;
                if (data && data.returnCode == 200) {
                    list = data.adAppRevenueInfoList;
                    totalCount = data.total;
                }

                return {
                    "total": totalCount,
                    "reportHicloudList": list
                }
            }
        }]
    );
});
